"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var react_1 = __importDefault(require("react"));
var Footer_module_scss_1 = __importDefault(require("./Footer.module.scss"));
var FooterContacts_1 = require("../footerContacts/FooterContacts");
var FooterInformation_1 = require("../footerInformation/FooterInformation");
var FooterDisclaimer_1 = require("../footerDisclaimer/FooterDisclaimer");
var FooterLegalInfo_1 = require("../footerLegalInfo/FooterLegalInfo");
var Footer = function () {
    return (react_1.default.createElement("footer", { className: Footer_module_scss_1.default.footer },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: Footer_module_scss_1.default.footer__inner },
                react_1.default.createElement(FooterContacts_1.FooterContacts, null),
                react_1.default.createElement(FooterInformation_1.FooterInformation, null),
                react_1.default.createElement(FooterDisclaimer_1.FooterDisclaimer, null),
                react_1.default.createElement(FooterLegalInfo_1.FooterLegalInfo, null)))));
};
exports.Footer = Footer;
